import ReportTexturePreference from './ReportTexturePreference';
export default ReportTexturePreference;
